import React, { useRef, useEffect, useState } from 'react';
import Button from '../../components/Button/Button';
import Input from '../../components/Input/Input';
import Modal from '../../components/Modal/Modal';
import './mytasksboard.scss';
import { ReactComponent as CloseIcon } from '../../images/Close.svg';
import { MdEdit } from 'react-icons/md';
// eslint-disable-next-line no-unused-vars
import { formatPhoneNumber, getCallStatus, getFormattedDate, getShortDate, getUTC } from '../../utils/functions';
import ConfirmationModal from '../../components/ConfirmationModal/ConfirmationModal';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import base from '../../apis';
import { toast } from 'react-toastify';
import Spinner from '../../components/Spinner/Spinner';
import { useSelector } from 'react-redux';
import { Loader, Select } from '@mantine/core';
import { Tooltip } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const productOptions = [
  { label: 'Farm Agent', value: 'farm_agent' },
  { label: 'Premier Agent', value: 'premier_agent' },
  { label: 'Deal Analyzer', value: 'evaluate_deals' },
  { label: 'Report Agent', value: 'starter_package' },
];

function MyTasksBoard() {
  const [addNewAgentModal, setAddNewAgentModal] = useState({
    open: false,
    edit: false,
  });
  const marketer_id = useSelector((state) => state.auth.marketerDetails.id);
  const isUS = useSelector((state) => state.auth.marketerDetails.category === 'us_agent');

  const { id } = useParams();
  const details = useLocation().state;
  const navigate = useNavigate();
  const newAgentForm = useRef();

  const [detailsModal, setDetailsModal] = useState(false);
  const [scheduleModal, setScheduleModal] = useState(false);
  const [isNext, setIsNext] = useState(false);
  const [sendModal, setSendModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [tasks, setTasks] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const ORIGINAL_TASKS = useRef([]);
  const [agent, setAgent] = useState({
    agent_first_name: '',
    agent_last_name: '',
    agent_phone: '',
    agent_email: '',
    last_call: '',
    next_call: '',
    call_status: '',
    comment: '',
    zoom_link: '',
  });
  const [agentBackup, setAgentBackup] = useState(null);

  const onAgentChange = (e) => {
    const { name, value } = e.target;
    setAgent({
      ...agent,
      [name]: value,
    });
  };

  useEffect(() => {
    if (!details) {
      navigate('/my-tasks/list/');
    }
  }, [details, navigate]);

  const getTasks = React.useCallback(() => {
    setIsLoading(true);
    setTasks([]);
    const controller = new AbortController();
    base
      .get(`/operations/offices/${id}/tasks/`, { signal: controller.signal })
      .then(({ data }) => {
        if (data?.length === 0) {
          toast.warn('No tasks found');
        }
        setTasks(data);
        ORIGINAL_TASKS.current = data;
      })
      .catch(() => {
        toast.error('Could not get office tasks');
      })
      .finally(() => {
        setIsLoading(false);
      });

    return () => {
      controller.abort();
    };
  }, [id]);

  useEffect(() => {
    getTasks();
  }, [getTasks]);

  const moveToNextStep = (e) => {
    e.preventDefault();
    newAgentForm.current.reportValidity();
    if (!newAgentForm.current.reportValidity()) return;

    setAddNewAgentModal({ edit: false, open: false });
    setDetailsModal(true);
  };

  const onEdit = () => {
    setAddNewAgentModal({ edit: true, open: true });
  };

  //a function onChangeStatus that set setfirstCall to true when the selection if equal to did not Answer
  const onChangeStatus = ({ target: { value } }) => {
    if (value === 'CB' || value === 'SZ') {
      setIsNext(true);
      setScheduleModal(true);
    }
    if (value !== 'SZ') {
      agent['zoom_link'] = null;
    }
    if (value !== 'CB' && value !== 'SZ') {
      agent['next_call'] = null;
    }
    setAgent({
      ...agent,
      call_status: value,
    });
    // if (value === 'Subscribed to BPO Farm Agent') {
    //   setSendModal(true);
    // }
  };

  const [date, setDate] = useState('');
  const [possibleAgents, setPossibleAgents] = useState([]);
  const [agentToSch, setAgentToSch] = useState(null);
  const [isMktsLoading, setIsMktsLoading] = useState(false);

  const setPerson = (person) => {
    setAgentToSch(person);
    setAgent((cur) => ({ ...cur, scheduled_marketer: person, marketer_appointment_date: new Date().toISOString() }));
  };

  const onCheckDateEntered = () => {
    if (!date) {
      toast.warn('Please enter a date');
      return;
    }
    if (!isNext) {
      setAgent((val) => ({ ...val, last_call: date }));
    } else {
      setAgent((val) => ({ ...val, next_call: date }));
      setIsMktsLoading(true);
      if (!isUS) {
        base
          .post('/operations/check_available_marketers/', {
            date_time: new Date(date).toISOString(),
          })
          .then(({ data }) => {
            if (data.length < 1) {
              toast.warn('No marketer available for this date');
              return;
            }
            setPossibleAgents(
              data.map((agent) => ({ label: `${agent?.user.first_name} ${agent?.user.last_name}`, value: agent.id }))
            );
          })
          .catch((err) => {})
          .finally(() => {
            setIsMktsLoading(false);
          });
      }
    }

    setScheduleModal(false);
  };

  const onSaveAgent = () => {
    if (!agent.last_call && isUS) {
      toast.warn('Please set the last contacted date');
      return;
    }
    if (!agent.call_status) {
      toast.warn('Please set the call status');
      return;
    }
    if (['CB', 'SZ'].includes(agent.call_status) && !agent.next_call) {
      setIsNext(true);
      toast.warn('Please set the next call date');
      return;
    }
    if (agent.call_status === 'SZ' && !agent.zoom_link) {
      toast.warn('Please set the virtual meeting link');
      return;
    }
    if (agent.call_status === 'SZ' && agent.zoom_link && !agent.zoom_link.includes('https:')) {
      toast.warn('Please enter a valid virtual meeting link');
      return;
    }
    if (!agent.comment && isUS) {
      toast.warn('Please set the comment');
      return;
    }

    const isEdit = 'id' in agent;
    const body = {
      ...agent,
    };
    if (!body.agent_email) {
      delete body.agent_email;
    }

    if (!body.next_call) {
      delete body.next_call;
    }
    if (!['CB', 'SZ'].includes(body.call_status)) {
      delete body.zoom_link;
      delete body.next_call;
    }
    body['marketer_id'] = agentToSch || agent.marketer_id || marketer_id;
    if (!agent?.last_call) {
      delete body['last_call'];
    }

    if (!isEdit) {
      body['office_id'] = +id;
    } else {
      delete body.id;
    }
    if (!isUS) {
      body.scheduled_marketer = marketer_id;
    } else {
      if (!!agentBackup) {
        body.client_status =
          agentBackup?.client_status !== agent.client_status ? agent.client_status : agentBackup.client_status;
        body.scheduled_marketer =
          agentBackup.scheduled_marketer !== agent.scheduled_marketer
            ? agent.scheduled_marketer
            : agentBackup.scheduled_marketer;
      }
    }

    const post = isEdit ? base.patch(`/operations/tasks/${agent.id}/`, body) : base.post(`/operations/tasks/`, body);
    setIsLoading(true);
    post
      .then(({ data }) => {
        toast.success('Task saved successfully');
        setIsLoading(false);
        setDetailsModal(false);
        getTasks();
      })
      .catch((err) => {
        toast.warn('Could not save task');
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const viewDetails = (task) => {
    // setAddNewAgentModal({ edit: false, open: true });
    setDetailsModal(true);
    setAgent(task);
    setAgentBackup(task);
  };

  const onAddNewAgent = () => {
    setAddNewAgentModal({ edit: false, open: true });
    setAgent({
      agent_first_name: '',
      agent_last_name: '',
      agent_phone: '',
      agent_email: '',
      last_call: '',
      next_call: '',
      call_status: '',
      comment: '',
      zoom_link: '',
    });
    setAgentBackup(null);
  };

  const [searchParams, setSearchParams] = useState({
    name: '',
    status: '',
  });

  const onChangeSearchParams = (e) => {
    const { name, value } = e.target;
    setSearchParams({
      ...searchParams,
      [name]: value,
    });
  };

  const onSearch = (e) => {
    e.preventDefault();
    let filtered = [];
    if (!searchParams.name && !searchParams.status) {
      filtered = ORIGINAL_TASKS.current;
    } else {
      filtered = ORIGINAL_TASKS.current.filter((task) => {
        if (
          searchParams.name &&
          `${task.agent_first_name}${task.agent_last_name}`.toLowerCase().includes(searchParams.name.toLowerCase())
        ) {
          return true;
        }
        if (searchParams.status && task.call_status === searchParams.status) {
          return true;
        }
        return false;
      });
    }
    setTasks(filtered);
  };

  const sendDetails = () => {
    const { agent_email } = agent;
    if (!agent_email) {
      toast.warn('No email address entered for agent');
      return;
    }
    if (!selectedProduct) {
      toast.warn('Please select a product');
      return;
    }
    setIsLoading(true);
    const body = {
      marketer_id,
      agent_email,
      agent_name: `${agent.agent_first_name} ${agent.agent_last_name}`,
      product_type: selectedProduct,
    };
    if (agent?.scheduled_marketer) {
      body.ghanaianmarkerter_id = agent?.scheduled_marketer;
    }
    base
      .post('/operations/send_marketing_ad/', body)
      .then(() => {
        toast.success('Email sent successfully');
      })
      .catch((err) => {
        toast.error('Error sending email');
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const onSubmitOffice = () => {
    setIsLoading(true);
    base
      .post('/operations/approve_office/', { office_id: +id })
      .then(() => {
        toast.success('Office submitted successfully');
        navigate('/my-tasks/list');
      })
      .catch(() => {
        toast.warn('Error submitting office');
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <>
      {isLoading && <Spinner />}
      <ConfirmationModal
        text="Send sign on link to agent?"
        onConfirm={() => setSendModal(false)}
        open={sendModal}
        onCancel={() => setSendModal(false)}
      />
      <Modal open={scheduleModal}>
        <div className="scont">
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}>
            <h4>Select Date & Time</h4>
            <input
              type="datetime-local"
              name="time"
              min={isNext ? new Date().toJSON().slice(0, 16) : ''}
              max={!isNext ? new Date().toJSON().slice(0, 16) : ''}
              id=""
              value={date}
              onChange={(e) => setDate(e.target.value)}
              style={{ padding: '10px' }}
            />
          </div>
          <div className="btns">
            <Button
              style={{
                width: '100px',
                fontSize: '16px',
                padding: '10px',
                color: 'white',
                backgroundColor: 'var(--primary-color)',
                display: 'block',
              }}
              onClick={() => setScheduleModal(false)}
              text="Cancel"
            />
            <Button
              style={{
                width: '100px',
                fontSize: '16px',
                padding: '10px',
                color: 'white',
                backgroundColor: 'var(--primary-color)',
                display: 'block',
              }}
              text="Save"
              onClick={() => onCheckDateEntered()}
            />
          </div>
        </div>
      </Modal>
      <Modal
        style={{ minWidth: '70vw' }}
        open={addNewAgentModal.open}
        onClose={() => setAddNewAgentModal({ edit: false, open: false })}>
        <div className="mod2" style={{ maxWidth: '70vw' }}>
          <div className="mod2header">
            <div>
              <p>{details?.branch}</p>
              <p>{`${details?.branch} - ${details?.state?.toUpperCase()}`}</p>
            </div>
            <CloseIcon
              onClick={() => setAddNewAgentModal({ edit: false, open: false })}
              style={{ fill: '#1378A5', cursor: 'pointer' }}
              width="18px"
              height="18px"
            />{' '}
          </div>
        </div>
        <form className="mtcontent" ref={newAgentForm}>
          <div>
            <div style={{ marginLeft: 'auto' }}>
              <span>Agent's First Name:</span>
              <Input
                placeholder="First Name"
                name="agent_first_name"
                value={agent.agent_first_name}
                onChange={onAgentChange}
                required
              />
            </div>
            <div>
              <span>Agent's Email:</span>
              <Input
                placeholder="Email"
                name="agent_email"
                value={agent.agent_email}
                type="email"
                onChange={onAgentChange}
              />
            </div>
          </div>
          <div>
            <div>
              <span>Agent's Last Name:</span>
              <Input
                placeholder="Last Name"
                value={agent.agent_last_name}
                onChange={onAgentChange}
                name="agent_last_name"
                required
              />
            </div>
            <div>
              <span>Agent's Phone Number:</span>
              <Input
                placeholder="Phone Number"
                value={agent.agent_phone}
                onChange={onAgentChange}
                name="agent_phone"
                required
              />
            </div>
            <Button
              style={{
                width: '100px',
                fontSize: '16px',
                padding: '10px',
                marginLeft: 'auto',
                color: 'white',
                backgroundColor: 'var(--primary-color)',
                display: 'block',
              }}
              onClick={moveToNextStep}
              text={'Next'}
            />
          </div>
        </form>
      </Modal>
      <Modal open={detailsModal} onClose={() => setDetailsModal(false)}>
        <div className="mod2" style={{ minWidth: '70vw' }}>
          <div className="mod2header">
            <div>
              <p>{details?.branch}</p>
              <p>{details?.address}</p>
            </div>
            <CloseIcon
              onClick={() => setDetailsModal(false)}
              style={{ fill: '#1378A5', cursor: 'pointer' }}
              width="18px"
              height="18px"
            />{' '}
          </div>
          <div className="bigg">
            <div>
              <p>
                Agent's Name: <b>{agent?.agent_first_name + ' ' + agent?.agent_last_name}</b>
                <button className="call" style={{ display: 'inline-flex', marginTop: 'unset' }} onClick={onEdit}>
                  <MdEdit /> <span>Edit</span>
                </button>
              </p>
              <p>
                Phone Number: <b>{formatPhoneNumber(agent?.agent_phone)}</b>
                <button className="call" style={{ display: 'inline-flex', marginTop: 'unset' }} onClick={onEdit}>
                  <MdEdit /> <span>Edit</span>
                </button>
              </p>
              <p>
                Agent's Email: <b>{agent?.agent_email || 'Not provided'}</b>
                <button className="call" style={{ display: 'inline-flex', marginTop: 'unset' }} onClick={onEdit}>
                  <MdEdit /> <span>Edit</span>
                </button>
              </p>
              <div className="script">
                <p>Script</p>
                <div>
                  Hey ________________How are you doing?
                  <br />
                  I am _________________ with BPO Tech. We have a meeting scheduled online today for Agents at the
                  __________ office at _____pm & at ______pm in order to help show the Agents how we can help you to get
                  more Listings, getting everyone off to a fast start for the New Year 2023.
                  <br />
                  <br />
                  Are you able to attend at least one of the meetings TODAY?
                  <br />
                  <br />
                  <b>(DON'T SAY ANYTHING AFTER AND LET THEM SPEAK)</b>
                  <br />
                  <br />
                  KEY POINTS
                  <br />
                  <br />
                  (We offer 100% FREE services or very low priced services to get you started)
                  <br />
                  <br />
                  We PAY you $100.00 for creating BPO Reports instead of FREE CMA's
                  <br />
                  You can sell BPO Reports to Sellers & Buyers and set SELLERS UP to receive Yearly BPO Reports.
                  <br />
                  <br />
                  We Call Sellers
                  <br />
                  We Text Sellers
                  <br />
                  We Mail Sellers
                  <br />
                  We CREATE Targeted Facebook Ads
                  <br />
                  We Brand you online and Advertise you to Sellers & Buyers in 5 cities of your choice on BPO Homes and
                  BPOTECH.com
                </div>
              </div>
            </div>
            <div>
              <p>
                Last Call: <b>{(agent?.last_call && getUTC(agent?.last_call)) || 'None'}</b>
                <button
                  className="call"
                  style={{ display: 'inline-flex', marginTop: 'unset' }}
                  onClick={() => {
                    setScheduleModal(true);
                    setDate(
                      agent.last_call
                        ? new Date(agent?.last_call).toJSON().slice(0, 16)
                        : new Date().toJSON().slice(0, 16)
                    );
                    setIsNext(false);
                  }}>
                  <MdEdit /> <span>Edit</span>
                </button>
              </p>
              <p>
                Status of Call:
                <select onChange={onChangeStatus} value={agent.call_status} style={{ marginLeft: '10px' }}>
                  <option value="">Select</option>
                  <option value="NI">Not Interested</option>
                  <option value="NA">Did Not Answer</option>
                  <option value="DC">Do Not Call Back</option>
                  <option value="CB">Call /Call Back</option>
                  <option value="SZ">Scheduled Virtual Appointment</option>
                  <option value="CC">Call Completed</option>
                </select>
              </p>
              {['CB', 'SZ'].includes(agent.call_status) && (
                <p>
                  Next Call: <b>{(agent.next_call && getUTC(agent.next_call)) || 'None'}</b>
                  <button
                    className="call"
                    style={{ display: 'inline-flex', marginTop: 'unset' }}
                    onClick={() => {
                      setScheduleModal(true);
                      setIsNext(true);
                      setDate(agent.next_call ? new Date(agent?.next_call).toJSON().slice(0, 16) : '');
                    }}>
                    <MdEdit /> <span>Edit</span>
                  </button>
                </p>
              )}
              {date && !isUS && (
                <p>
                  Scheduled for:{' '}
                  {isMktsLoading ? (
                    <Loader size="xs" variant="dots" />
                  ) : (
                    <Select data={possibleAgents} value={agent.scheduled_marketer} onChange={setPerson} />
                  )}
                </p>
              )}
              {agentBackup?.scheduled_marketer && !isUS && (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <span>Already scheduled?</span>
                  <Tooltip title="Already scheduled to agent. Edit next call time to update">
                    <CheckCircleIcon color="primary" />
                  </Tooltip>
                </div>
              )}
              {agent.call_status === 'SZ' && (
                <Input
                  placeholder="Zoom Link"
                  name="zoom_link"
                  value={agent.zoom_link}
                  type="url"
                  onChange={onAgentChange}
                />
              )}

              {isUS && (
                <Select
                  data={[
                    { label: 'Agent showed up', value: 'client_did_not_pick' },
                    { label: 'Agent did not show up', value: 'client_picked' },
                  ]}
                  value={agent.client_status || ''}
                  onChange={(val) => setAgent({ ...agent, client_status: val })}
                  label="Client Status"
                />
              )}

              <div>
                <p>Comment Section</p>
                <textarea
                  cols="30"
                  rows="5"
                  placeholder="Post update/Feedback"
                  value={agent.comment}
                  name="comment"
                  onChange={onAgentChange}></textarea>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                {isUS && (
                  <>
                    <Select placeholder="Product to send" data={productOptions} onChange={setSelectedProduct} />
                    <Button
                      style={{
                        width: 'fit-content',
                        fontSize: '16px',
                        padding: '10px',
                        color: 'white',
                        marginLeft: '5px',
                        backgroundColor: 'var(--primary-color)',
                        display: 'block',
                        marginTop: '0',
                      }}
                      onClick={sendDetails}
                      text="Send Signup  Link"
                    />
                  </>
                )}
                <Button
                  style={{
                    width: 'fit-content',
                    fontSize: '16px',
                    padding: '10px',
                    color: 'white',
                    marginLeft: 'auto',
                    backgroundColor: 'var(--primary-color)',
                    display: 'block',
                    marginTop: '0',
                  }}
                  onClick={onSaveAgent}
                  text="Save"
                />
              </div>
            </div>
          </div>
        </div>
      </Modal>
      <div className="mtboard">
        <form className="modinputs" onSubmit={onSearch}>
          <Input
            type="search"
            value={searchParams.name}
            onChange={onChangeSearchParams}
            name="name"
            fullStyles={{ flex: 1 }}
            placeholder="Enter Agent Name"
            style={{ fontSize: '16px', padding: '10px 20px' }}
          />
          <select
            name="status"
            value={searchParams.status}
            onChange={onChangeSearchParams}
            style={{ marginLeft: '10px', flex: 1 }}>
            <option value="">None</option>
            <option value="NI">Not Interested</option>
            <option value="NA">Did Not Answer</option>
            <option value="DC">Do Not Call Back</option>
            <option value="CB">Call Back</option>
            <option value="SZ">Scheduled Virtual Appointment</option>
          </select>
          <Button
            style={{
              width: '100px',
              fontSize: '16px',
              padding: '10px',
              color: 'white',
              backgroundColor: 'var(--primary-color)',
              display: 'block',
            }}
            text="Filter"
          />
        </form>
        <div className="hol" style={{ marginTop: '10px' }}>
          <Button
            style={{
              width: 'fit-content',
              fontSize: '16px',
              padding: '10px',
              color: 'white',
              backgroundColor: 'var(--primary-color)',
              display: 'block',
            }}
            onClick={onAddNewAgent}
            text="+ Add Agent"
          />
          <a
            href={details?.web_link}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              width: 'fit-content',
              fontSize: '16px',
              padding: '8px',
              color: 'white',
              backgroundColor: 'var(--primary-color)',
              borderRadius: '5px',
              cursor: 'pointer',
            }}>
            Get Agent List Record
          </a>
          <Button
            style={{
              width: 'fit-content',
              fontSize: '16px',
              padding: '10px',
              color: 'white',
              backgroundColor: '#FFAA01',
              borderColor: '#FFAA01',
              display: 'block',
              marginLeft: 'auto',
            }}
            onClick={onSubmitOffice}
            text="Submit Office"
          />
        </div>
        <div className="deta">
          {tasks.map((task) => (
            <SummaryCard key={task.id} {...task} onClick={() => viewDetails(task)} />
          ))}
        </div>
      </div>
    </>
  );
}

export default MyTasksBoard;

const SummaryCard = ({ onClick, agent_first_name, agent_last_name, call_status, next_call, last_call }) => {
  const date = React.useRef(getShortDate(next_call || last_call));
  return (
    <div className="ditem" onClick={onClick}>
      <div>
        <div>
          <h3>{agent_first_name + ' ' + agent_last_name}</h3>
        </div>
        <div>
          <p>Last Call Status</p>
          <p>{getCallStatus(call_status)}</p>
        </div>
      </div>
      <div>
        <div>
          <span>{date.current?.split(' ')?.[0]}</span>
          <span>{date.current?.split(' ')?.[2]}</span>
          <span>{date.current?.split(' ')?.[1]}</span>
        </div>
      </div>
    </div>
  );
};
